// Template thumbnail overrides persisted on the API (Snapshot uploads).
const API_BASE = "/api"

export const uploadTemplateThumb = async (templateId: string, dataUrl: string): Promise<boolean> => {
  try {
    const res = await fetch(`${API_BASE}/thumbnails/${encodeURIComponent(templateId)}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ dataUrl }),
    })
    return res.ok
  } catch {
    return false
  }
}

export const fetchTemplateThumbs = async (): Promise<Record<string, string>> => {
  try {
    const res = await fetch(`${API_BASE}/thumbnails`, { cache: "no-store" })
    if (!res.ok) return {}
    const data = await res.json()
    const map: Record<string, string> = {}
    for (const thumb of data?.thumbnails || []) {
      if (thumb?.id) map[thumb.id] = `${API_BASE}/thumbnails/${thumb.id}?v=${thumb.updatedAt}`
    }
    return map
  } catch {
    return {}
  }
}
